import { createDomain } from 'effector';

import { type RegisteredModals } from 'types/Modals';

const domain = createDomain('modals');

export const setShouldMount = domain.event<{ modalName: RegisteredModals; shouldMount: boolean }>();
export const setModalState = domain.event<{ modalName: RegisteredModals; state?: any }>();
export const setIsOpened = domain.event<{ modalName: RegisteredModals; isOpened: boolean }>();
export const remove = domain.event<RegisteredModals>();
export const setPreventClosing = domain.event<{ modalName: RegisteredModals; preventClosing: boolean }>();
export const hideModal = domain.event<RegisteredModals>();
export const showModal = domain.event<{ modalName: RegisteredModals; state?: any }>();
